import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
  html {
    background-color: ${props => props.theme.colors.background.primary};
    box-sizing: border-box;
    color: ${props => props.theme.colors.content.primary};
    font-size: 16px;
    height: 100%;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
  }

  *, *:before, *:after {
    box-sizing: inherit;
  }

  body, #__next {
    height: 100%;
  }

  body, h1, h2, h3, h4, h5, h6, p, ol, ul {
    font-weight: normal;
    margin: 0;
    padding: 0;
    width: 100%;

    > img {
      display: none;
    }
  }

  ol, ul {
    list-style: none;
  }

  img {
    height: auto;
    max-width: 100%;
  }

  select:-moz-focusring {
    color: transparent;
    text-shadow: 0 0 0 #000;
  }

  b {
    font-family: ${props => props.theme.fontFamilies.main.medium};
  }
`;
